export const stringNotEmpty = (v: string | null | undefined): v is string => v != null && v.trim().length > 0;
export const stringIsEmpty = (v: string | null | undefined) => !stringNotEmpty(v);